<template>
<v-main class="pa-3 pb-4">
  <TabelaFuncionarios :lista-funcionarios-ativos="listaFuncionariosAtivos" :lista-funcionarios-desativos="listaFuncionariosDesativos" :descricao-funcionario="'Painéis'" :tipo-funcionario="'1'" @alterar-dados-funcionario="alterarDadosFuncionario" @ativar-funcionario="ativarFuncionario" @desativar-funcionario="desativarFuncionario" />
  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn id="mybutton" top-of="footer" right fab dark color="teal darken-4" :to="{path:'/cadastrarPainelUnidade'}" @click="">
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import TabelaFuncionarios from './../../../assets/components/TabelaFuncionarios'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'ListaVisoresUnidade',
  components: {
    TabelaFuncionarios
  },
  data () {
    return {

      searchAtivo: '',
      searchDesativo: '',
      isEditing: true,
      tipo: 6,
      listaFuncionarios: [],
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      headers: [{
        text: 'Identificação do painel',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        value: 'name',
        sortable: true,
        align: 'center'
      }

      ],
      headersDesativo: [{
        text: 'Identificação do painel ',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ativar Visor',
        value: 'name',
        align: 'center',
        sortable: false
      }
      ],
      listaLocais: [],
      user: null
    }
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarFuncionarios()
  },
  created () {
    console.log('created...')
  },
  methods: {

    ativarFuncionario (item) {
      console.log('ativ')
      if (confirm('Deseja ativar esse painel?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosDesativos.indexOf(item)
        console.log('excluir painel..')
        console.log(typeof (item.username))
        administradorUnidadeService.administradorUnidade.ativarFuncionario(item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    alterarDadosFuncionario (item) {
      this.$router.push({
        name: 'alterarDadosPainel',
        params: {
          item: item
        }
      })
    },

    desativarFuncionario (item) {
      console.log('desat')
      if (confirm('Deseja desativar esse painel?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosAtivos.indexOf(item)
        console.log('excluir painel..')
        console.log(typeof (item.username))

        administradorUnidadeService.administradorUnidade.desativarFuncionario(item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    editarVisor (item) {
      console.log('em alterar dados painel...')
      this.$router.push({
        name: 'alterarDadosPainel',
        params: {
          item: item
        }
      })
    },

    retornarFuncionarios () {
      console.log('em retornar visores adm...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.listaFuncionarios = rsp.data
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else {
              this.listaFuncionariosDesativos.push(funcionario)
            }
          })
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
